import React from 'react';
import './positions.css';

const Positions = () => {
  return (
    <div className='tableWrapper'>
      <p className='p-pos'>No positions available without inserting API KEY</p>
    </div>
  );
};

export default Positions;